import React, { Fragment, useEffect, useState, useContext } from "react";
import { Typeahead } from "react-bootstrap-typeahead";

/**
 * Componente reutilizable para manejar selector multiple tipo tags
 * !Si se desea trabajar con selecccion unica usar el componente CustomSelect
 */
const CustomMultipleSelect = ({
  register,
  setValue,
  items,
  name,
  placeholder,
  errors,
  item,
  customChangeHandler,
}) => {
  const [model, setModel] = useState([]);

  const handleInputChange = (input, e) => {
    if (setValue) {
      setValue(name, input, {
        shouldDirty: true,
        shouldTouch: true,
        shouldValidate: true,
      });
    }

    let itemsIds = input.map((e) => e.id);
    let selected = items.filter((e) => itemsIds.includes(e.id));
    setModel(selected);

    if (customChangeHandler != undefined) {
      customChangeHandler(input);
    }
  };

  useEffect(() => {
    if (item) {
      if (setValue) {
        setValue(name, item[name], {
          shouldDirty: false,
          shouldTouch: true,
          shouldValidate: true,
        });
      }

      if (item[name]) {
        let itemsIds = item[name].map((e) => e.id);

        let selected = items.filter((e) => itemsIds.includes(e.id));

        if (selected) {
          setModel(selected);
        }
      }
    }
  }, [items, item]);

  ///on componenmt destroy
  useEffect(() => {
    return () => {};
  }, []);
  return (
    <>
      <input
        type="hidden"
        name={name}
        id={name}
        {...(register && register(`${name}`, {}))}
      ></input>

      <Typeahead
        id="public-typeahead"
        selected={model}
        labelKey="name"
        multiple
        options={items}
        placeholder={placeholder}
        onChange={handleInputChange}
        className={`form-select ${errors && errors[name] && "is-invalid"}`}
      />
    </>
  );
};

export default CustomMultipleSelect;
